/**
 * @author Ivan Toth.
 */
var CommentController = (function () {
    function CommentController(topic, Dialog, $state, settings, $attrs) {
        this.topic = topic;
        this.Dialog = Dialog;
        this.$state = $state;
        this.settings = settings;
        this.$attrs = $attrs;
        this.comp = 'comments'; // + $<active tabname>
        this.updateArray = ['comments']; //+ $<active tabname>
        this.visible = false;
    }
    ;
    /**
     * Removed the detail. part, so I get the active tab name
     */
    CommentController.prototype.$onInit = function () {
        if (this.$attrs.section) {
            this.section = this.$attrs.section;
            this.activeTab = this.section;
        }
        else {
            this.section = this.topic.tabs.short;
            this.activeTab = this.$state.current.name.replace('detail.', '');
        }
        this.comp = 'comments$' + this.section;
        this.updateArray = ['comments$' + this.section];
        if (this.topic.topic.comments[this.section] && this.topic.topic.comments[this.section].length) {
            this.topic.topic.comments[this.section] = this.topic.topic.comments[this.section].sort(function (a, b) { return a.time.localeCompare(b.time); });
        }
    };
    /**
     * Toggles the visibility of the comments table
     */
    CommentController.prototype.toggle = function () {
        this.visible = this.visible ? false : true;
    };
    /**
     * adds a comment based on which tab, the component was clicked. It takes the activeTab from the state name.
     * calls a dialog where you can insert a comment. In case cancel was pressed nothing happens
     * After submitted comment, I call the sendForUpdateGeneral to start the process of uploading
     * @param event - in html I'm passing the $event.
     */
    CommentController.prototype.addComment = function (event) {
        var _this = this;
        var items;
        //Here to add the comment into the server
        //this.topic.clearTempComments();
        if (!this.$attrs.section) {
            this.activeTab = this.topic.tabs.short;
        }
        items = { dialogName: this.activeTab };
        //Ensure the comments.object exists on the topic...and if not, add it
        var objArray = this.comp.split('$');
        if (objArray.length === 2 && angular.isUndefined(this.topic.topic[objArray[0]][objArray[1]])) {
            this.topic.topic[objArray[0]][objArray[1]] = [];
        }
        this.Dialog.updateValidForm(event, items, 'detail-comment-dialog.html').then(function (dResult) {
            if (!angular.isUndefined(dResult)) {
                if (_this.topic.updatePartialSocketStatus(_this.updateArray, 'Updating')) {
                    _this.topic.setTempFromTopicPart(_this.comp);
                    _this.topic.temp.comments[dResult.dialogName].push({
                        time: (new Date()).getTime(),
                        source: _this.topic.settings.up.email,
                        comment: dResult.comment,
                        section: _this.topic.tabs.short
                    });
                    _this.topic.sendCommentForUpdateGeneral(_this.updateArray, true);
                }
            }
            return;
        });
    };
    CommentController.$inject = ['topic', 'Dialog', '$state', 'settings', '$attrs'];
    return CommentController;
}());
var CommentComponent = (function () {
    function CommentComponent() {
        this.templateUrl = 'detail-comment.html';
        this.controllerAs = 'vm';
        this.controller = CommentController;
    }
    return CommentComponent;
}());
angular
    .module('application')
    .component('detailComment', new CommentComponent());

//# sourceMappingURL=detail.comment.components.js.map
